import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

/**
 * 
 * @param {Phaser.GameObjects.GameObject} obj 
 * @param {number} time 
 * @param {number} wait 
 * @returns 
 */
export function dotPop(obj, time = 320, wait = 0) {
  obj.scene.tweens.killTweensOf(obj);
  ABCyaPhaser.Tweens.addTween(obj,240, { scale: 1.6, alpha: 1, delay: wait }, Phaser.Math.Easing.Quadratic.In, () => {
    ABCyaPhaser.Tweens.addTween(obj,time, { scale: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
  });
}